import template from './loginScreen.html';
import controller from './loginScreen.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    onLogin: '&',
  },
};

export default component;
